@let $isPostPayment = isPostPayment | async;

<mbs-modal
  #modal
  class="select-license-modal overflow-visible"
  [isCustomModal]="true"
  [showFooter]="true"
  [title]="baseModal.data.title"
  [titleTextOverflow]="true">
  <div modal-body>
    @if ((isLinux || isMac || isServer) && !$isPostPayment) {
      <div class="text-md mb-3">
        @switch (true) {
          @case (isLinux) {
            <span [innerHTML]="'shared:licenses.management.availableLicenseForLinux' | i18next"></span>
          }
          @case (isMac) {
            <span [innerHTML]="'shared:licenses.management.availableLicenseForMac' | i18next"></span>
          }
          @case (isServer && !isLinux && !isMac) {
            <span [innerHTML]="'shared:licenses.management.availableLicenseForServer' | i18next"></span>
          }
        }
        <a
          target="_blank"
          [helpLink]="'/licenses/manage-licenses'"
          >{{ 'shared:buttons.learnMore' | i18next }}...</a
        >
      </div>
    }

    @if ($isPostPayment) {
      <div class="pb-3">
        {{ 'shared:licenses.manageModal.description' | i18next }}
      </div>
    }

    @if (licensePool) {
      <div class="mb-3">
        <mbs-input-label
          [boldLabel]="true"
          [label]="'License pool' | i18next"></mbs-input-label>

        @let subjectName = licensePool?.subject?.name;

        @if (subjectName) {
          <div>{{ licensePool?.name }} <span class="text-gray-300">|</span> {{ subjectName }}</div>
        } @else {
          <div>{{ licensePool?.name }}</div>
        }
      </div>
    }

    <mbs-select-license-form
      [companyId]="computer?.company?.id"
      [computer]="computer"
      [form]="form"
      [kind]="kind"
      [licenseTypeId]="licenseTypeId"
      [pool]="licensePool"></mbs-select-license-form>
    @if (showRMMPECEAlert()) {
      <mbs-alert
        class="mt-3 mb-0"
        [icon]="true"
        [type]="mbsPopupType.danger">
        {{ 'shared:licenses.rmmPECEAssignLimitAlert' | i18next }}
      </mbs-alert>
    }
  </div>
  <ng-container modalFooter>
    <mbs-button
      type="primary"
      [disabled]="isApplyBtnDisabled(isPostPayment | async)"
      [loading]="setLicenseLoading()"
      (click)="isSelectBuyLicense ? buyLicense() : setLicense()">
      {{ isSelectBuyLicense ? ('shared:buttons.buy' | i18next) : ('shared:buttons.save' | i18next) }}
    </mbs-button>
    <mbs-button
      data-dismiss="modal"
      type="secondary"
      (click)="modal.close()">
      {{ 'shared:buttons.cancel' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
